import React from 'react';
import { Redirect } from 'react-router-dom';

const RootPage = (props) => {
  if (props.loading) {
    return (
      <div className="loading-background">
        <div id="circle2" />
      </div>
    );
  }
  if (props.authenticated && !props.done) return <Redirect to="/survey" />;
  else if (props.authenticated && props.done) return <Redirect to="/feed" />;
  else return <Redirect to="/landing" />;
};

export default RootPage;
